import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Zero-based index of the slide that should be visible. Two-way: emits update-selected-index whenever the active slide changes.
   *
   * @type {Number}
   * @default 0
   * @storybook-control number
   */
  selectedIndex: {
    type: Number,
    default: 0,
  },
  /**
   * Number of slides visible together. Omit to retain the existing CSS layout.
   * @type {Number}
   * @default undefined
   * @storybook-control number
   */
  slidesPerView: { type: Number, default: undefined },
  /**
   * Number of slides advanced by the arrows and keyboard.
   * @type {Number}
   * @default 1
   * @storybook-control number
   */
  slidesToScroll: { type: Number, default: 1 },
  /**
   * Minimum container widths mapped to slidesPerView, slidesToScroll and arrows overrides. Pass an object property or JSON attribute.
   * @type {Object|String}
   * @default {}
   * @storybook-control object
   */
  breakpoints: { type: [Object, String], default: () => ({}) },
  /**
   * Loop through the original slides without making copies.
   * @type {Boolean}
   * @default false
   * @storybook-control boolean
   */
  infinite: booleanAttribute(),
  /**
   * Show outlined previous and next controls.
   * @type {Boolean}
   * @default false
   * @storybook-control boolean
   */
  arrows: booleanAttribute(),
  /**
   * Show one dot per navigation position.
   * @type {Boolean}
   * @default false
   * @storybook-control boolean
   */
  dots: booleanAttribute(),
  /**
   * Accessible region name describing this slider's content.
   * @type {String}
   * @default undefined
   * @storybook-control text
   */
  regionLabel: { type: String, default: undefined },
});
